import React, { useState } from 'react';
import  { Link, useNavigate } from 'react-router-dom';
import './StepQuestionnaire.css';
import './login.css';
import './CreateFirm.css';
import { storeFirmSession } from '../auth/firmSession';
import { preparePortalLogin } from '../mobile/accountSession';
import { flushSessionVault } from '../mobile/sessionVault';
import {
  CContainer,
  CForm,
  CFormInput,
  CButton, // ✅ This line is key!
  CAlert,
  CCard,
  CCardBody,
  CCardHeader,
  CRow,
  CCol,
} from '@coreui/react';
const API_URL = process.env.REACT_APP_API_URL;
const FirmLoginPage = () => {
  const [formData, setFormData] = useState({ id: '', password: '' });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);
  const [showForgotModal, setShowForgotModal] = useState(false);
  const [resetEmail, setResetEmail] = useState('');
  const [resetStatus, setResetStatus] = useState(null);
  const [resetLoading, setResetLoading] = useState(false);
  const [step, setStep] = useState(1);  // 1 = ID input, 2 = password input
  const [needsPasswordSetup, setNeedsPasswordSetup] = useState(false);
  const navigate = useNavigate();
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    setSuccess('');
  
    try {
      const res = await fetch(`${API_URL}/login/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
  
      const data = await res.json();
      if (res.ok && data.needs_password_setup) {
        // first time login
        window.location.href = `/set-password?firm=${formData.id}`;
      } else if (res.ok) {
        await preparePortalLogin('firm');
        setSuccess('Login successful');
        storeFirmSession({ access: data.access, refresh: data.refresh });
        await flushSessionVault();

        // Redirect to dashboard
        navigate('/dashboard');
      } else {
        setError(data?.detail || 'Invalid credentials');
      }
    } catch {
      setError('Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="step-questionnaire-container">
      <h1 className="top-header">Firm Login</h1>
      <div className="question-box-login">
      <img 
          src="images/firm-login-banner.png" 
          alt="Firm Login Banner" 
          className="login-banner-image" 
        />
        <form onSubmit={handleLogin}>
        <div className="vertical-stack">
          <input
            type="text"
            name="id"
            autoComplete="username"
            autoCapitalize="none"
            className="text-input"
            placeholder="Firm ID or Email"
            value={formData.id}
            onChange={handleChange}
            required
          />

          {step === 2 && (
            <input
              type="password"
              name="password"
              autoComplete="current-password"
              className="text-input"
              placeholder="Password"
              value={formData.password}
              onChange={handleChange}
              required
            />
          )}
        </div>

        <div className="vertical-stack">
          {error && <div className="error-text mt-2">{error}</div>}
          {success && <div className="success-text mt-2">{success}</div>}
          <CButton
            type="submit"
            className="binary-button"
            color="primary"
            disabled={loading}
            onClick={() => step === 1 && setStep(2)}  // Go to step 2 if first step
          >
            {loading ? 'Logging in...' : step === 1 ? 'Next' : 'Login'}
          </CButton>

          <div className="text-center mt-2">
            <a href="#" onClick={(e) => { e.preventDefault(); setShowForgotModal(true); }}>
              Forgot password?
            </a>
          </div>
          <div className="text-center mt-2">
            <Link to="/create-firm">Register</Link>
          </div>
        </div>
      </form>
      </div>

      {showForgotModal && (
        <div className="modal-overlay">
          <div className="modal-box">
            <h3>Reset Password</h3>
            <input
              type="email"
              className="text-input"
              placeholder="Enter your email"
              value={resetEmail}
              onChange={(e) => setResetEmail(e.target.value)}
            />
            {resetStatus && <p>{resetStatus}</p>}
            <div>
              <button
                type="button"
                className="binary-button"
                disabled={resetLoading}
                onClick={async () => {
                  setResetLoading(true);
                  try {
                    const res = await fetch('https://api.cisowskilaw.com/api/password-reset-request', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json' },
                      body: JSON.stringify({ email: resetEmail }),
                    });
                    const data = await res.json();
                    if (res.ok) {
                      setResetStatus('A reset link has been sent to your email.');
                    } else {
                      setResetStatus(data?.error || 'Could not process your request.');
                    }
                  } catch (err) {
                    setResetStatus('Something went wrong.');
                  } finally {
                    setResetLoading(false);
                  }
                }}
              >
                {resetLoading ? 'Resetting...' : 'Reset'}
              </button>
              <button
              className = "binary-button"
                type="button"
                onClick={() => {
                  setShowForgotModal(false);
                  setResetStatus(null);
                  setResetEmail('');
                }}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default FirmLoginPage;
